import { createMachine } from 'xstate';
import { settingsResolve } from '@fingermarkglobal/settings'
import { SettingsMachineContext } from '@fingermarkglobal/types';
import {
  setSettingsAction,
  sendParentFailureAction,
  sendParentSuccessAction
} from './actions';

const settingsMachine = createMachine<SettingsMachineContext>(
  {
    id: 'settings-machine',
    initial: 'populating',
    context: {
      count: null,
      serial: null,
      settings: null
    },
    states: {
      populating: {
        invoke: {
            src: (context) => settingsResolve(context?.serial),
            onDone: {
              target: 'success',
              actions: ['setSettingsAction']
            },
            onError: {
              target: 'failure'
            }
        }
      },
      success: {
        entry: ['sendParentSuccessAction'],
        type: 'final'
      },
      failure: {
        entry: ['sendParentFailureAction'],
        type: 'final'
      }
    }
  },
  {
    actions: {
      setSettingsAction,
      sendParentFailureAction,
      sendParentSuccessAction
    }
  }
);

export { settingsMachine };
